import AggregateRatingSummary from './AggregateRatingSummary';

const { getSeoLandingPageBreadcrumbs } = require('../../seo/landingPages');
const { DEFAULT_SEO_CONTENT } = require('../../seo/seoContent');

const languageNames = {
    ca: 'català', es: 'castellà', en: 'anglès', de: 'alemany',
    ar: 'àrab', hy: 'armeni', az: 'azerbaidjanès', eu: 'basc',
    be: 'bielorús', bn: 'bengalí', bg: 'búlgar', hr: 'croat',
    ko: 'coreà', da: 'danès', nl: 'holandès', sk: 'eslovac',
    sl: 'eslovè', et: 'estonià', tl: 'filipí', fi: 'finès',
    fr: 'francès', gl: 'gallec', ka: 'georgià', cy: 'gal·lès',
    el: 'grec', gu: 'gujarati', iw: 'hebreu', hi: 'hindi',
    hu: 'hongarès', is: 'islandès', id: 'indonesi', ga: 'irlandès',
    it: 'italià', ja: 'japonès', yi: 'jiddisch', kn: 'kannada',
    la: 'llatí', lv: 'letó', lt: 'lituà', mk: 'macedoni',
    ms: 'malai', mt: 'maltès', no: 'noruec', fa: 'persa',
    pl: 'polonès', pt: 'portuguès', ro: 'romanès', ru: 'rus',
    sr: 'serbi', sw: 'swahili', sv: 'suec', ta: 'tàmil',
    te: 'telugu', th: 'tailandès', tr: 'turc', cs: 'txec',
    uk: 'ucraïnès', ur: 'urdú', vi: 'vietnamita', zh: 'xinès',
};

function Breadcrumbs({ landingPage }) {
    const breadcrumbs = getSeoLandingPageBreadcrumbs(landingPage);
    if (!breadcrumbs.length) return null;

    const lastIndex = breadcrumbs.length - 1;
    return (
        <nav className="breadcrumbs" aria-label="Ruta de navegació">
            <ol>
                {breadcrumbs.map((crumb, index) => (index === lastIndex
                    ? <li key={crumb.path} aria-current="page">{crumb.name}</li>
                    : <li key={crumb.path}><a href={crumb.path}>{crumb.name}</a></li>))}
            </ol>
        </nav>
    );
}

function Header({ language, landingPage }) {
    const langName = languageNames[language] || 'català';
    const headingText = landingPage?.heading || (language === 'ca'
        ? DEFAULT_SEO_CONTENT.heading
        : `Transcripció automàtica en ${langName}`);
    const introText = landingPage?.intro || (language === 'ca'
        ? DEFAULT_SEO_CONTENT.intro
        : `Aquesta web et permet transcriure fitxers d'àudio automàticament, fins i tot si tenen hores de durada.`);
    return (
        <header>
            <Breadcrumbs landingPage={landingPage} />
            <h1>{headingText}</h1>
        <p id="intro-header">
                {introText}
        </p>
        <AggregateRatingSummary language={language} />
        </header>
    );
}

export default Header;
